import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private version = '';

  set(version: string) {
    this.version = version;
  }

  get(): string {
    return this.version;
  }
}
